import { events } from './events';
import Info from './Info';

export default {
  // this.$showInfo( "templateName" ) вызывает модальное окно
  // с компонентом "templateName" из "./templates/templateName"
  install(Vue) {
    if (this.installed) { return; }
    this.installed = true;

    Vue.component('capustaInfo', Info);

    Vue.prototype.$showInfo = function (templateName) {
      events.$emit('show', templateName);
    };
  },
};
